import React from 'react';

//components
import AirTemp from './AirTemp';
import LeafTemp from './LeafTemp';
import Pressure from './Pressure';
import LeafWetness from './LeafWetness';
import RelativeHumidity from './RelativeHumidity';
import WaterVapor from './WaterVapor';
import Precipitation from './Precipitation';
import WindDirection from './WindDirection';
import WindSpeed from './WindSpeed';

const components = {
  compA: AirTemp,
  compB: LeafTemp,
  compC: Pressure,
  compD: LeafWetness,
  compE: RelativeHumidity,
  compF: WaterVapor,
  compG: Precipitation,
  compH: WindDirection,
  compI: WindSpeed
};

const DynamicSections = ({ tab, data }) => {
  const SelectedTab = components[tab];
  return <SelectedTab data={data} />;
};

export default DynamicSections;
